import styled, { css } from "styled-components";

import AtomXSSearchIcon from "Components/Atoms/Search/XSSearchIcon";
import AtomXSSearchInput from "Components/Atoms/Search/XSSearchInput";

import * as Types from "Types";

const Wrap = styled.label<Types.Default>`
   cursor: pointer;
   display: flex;
   align-items: center;
   opacity: 1;
   transition: opacity 0.3s ease-in-out;
   ${({ css }) => css}
`;

function Search(props: any) {
   console.log("search props", props);
   return (
      <Wrap css={props.css}>
         <AtomXSSearchInput onChange={props.onChange} onKeyDown={props.onKeyDown} value={props.value} inputRef={props.inputRef} onBlur={props.onBlur}></AtomXSSearchInput>
         <AtomXSSearchIcon
            css={css`
               opacity: 0;
            `}></AtomXSSearchIcon>
      </Wrap>
   );
}

export default Search;
